import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class FatigueReasonReportsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      report_data: [],
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.expandComponent = this.expandComponent.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reporte/voluntario/abertos', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  ActionsButtons (cell, row) {
    var button = (
     <button className="btn btn-primary"><i className="fa fa-fw fa-eye"></i></button>
    );

    return button;
  }

  confirmReport (id) {
    this.handleAlert('', '', 'open');
    var datasave = {
      id: id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/fadiga/voluntaria/arquivar/' + id;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
 expandComponent(row) {
    return (
      <div className="expandable-row">
        <div className="row">
          <div className="col-md-6 text-center">
            <h4>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tituloMotivo}</h4>
            <hr/>
            <p>{row.fatigue_reason_name}</p>
          </div>
          <div className="col-md-6 text-center">
            <h4>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tituloObservacoes}</h4>
            <hr/>
            <p>{row.observations}</p>
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-12 text-center">
            <button onClick={() => { this.confirmReport(row.id) }} className="btn btn-success btn-block"><i className="fa fa-fw fa-check"></i> {this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.botaoConfirmarVisualizacao}</button>
          </div>
        </div>        
      </div>
    );
  }
  
 expandableRow(row) {
    return true;
  }

  render() {
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.semParametroDeFadiga, expandRowBgColor: 'rgb(235, 235, 235)'}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar} expandComponent={ this.expandComponent } expandableRow={ this.expandableRow }>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Tripulante}</TableHeaderColumn>
        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='80'>{this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Acoes}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueReasonReportsIndex;



// WEBPACK FOOTER //
// ./src/Components/FatigueReasons/FatigueReasonReportsIndex.js